'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userGuardians = require('./user-guardians.html');

var _userGuardians2 = _interopRequireDefault(_userGuardians);

var _userGuardians3 = require('./user-guardians.controller');

var _userGuardians4 = _interopRequireDefault(_userGuardians3);

require('./user-guardians.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userGuardiansComponent = {
  restrict: 'E',
  bindings: {
    guardians: '<'
  },
  template: _userGuardians2.default,
  controller: _userGuardians4.default,
  controllerAs: 'vm'
};

exports.default = userGuardiansComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-guardians/user-guardians.component.js
 **/